<template>
  <div class="catalog">
    <p class="title">已选学科</p>
    <div class="list-box">
      <el-button
        v-for="(item,index) in newDefaultSelectStructure"
        :key="index"
        size="mini"
        type="primary"
        class="btn"
        plain>{{ lessonName[item.subject_id] }}</el-button>
    </div>
    <div class="row">
      <p class="name">学科</p>
      <el-select
        v-model="newSelectStructure"
        size="mini"
        placeholder="请选择"
        @change="handleSelectStruct"
      >
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"/>
      </el-select>
    </div>
    <!--    <div class="row radio">-->
    <!--      <p class="name">是否开放课时预览</p>-->
    <!--      <el-radio-group v-model="radio">-->
    <!--        <el-radio :label="1">是</el-radio>-->
    <!--        <el-radio :label="0">否</el-radio>-->
    <!--      </el-radio-group>-->
    <!--    </div>-->
    <TreeBox
      ref="tree"
      :subject-id.sync="selectStructure"
      :default-value="defaultValue"
      @onTreeBox="onTreeBox"
      @onSelected="onSelected"
      @onCheck="onCheck"
      @success="onSuccessTree"
    />
  </div>
</template>

<script>
import TreeBox from './components/treeBox';

export default {
  name: 'Catalog',
  components: {
    TreeBox,
  },
  props: {
    defaultSelectStructure: Array, // 已选学科 - 默认所有数据
    selectStru: [String, Number],
    defaultValue: Array,
  },
  data() {
    return {
      selectStructure: '', // 当前选中的结构id
      newSelectStructure: this.selectStru,
      radio: '',
      options: [],
      newDefaultSelectStructure: this.defaultSelectStructure,
    };
  },
  computed: {
    lessonName() {
      const obj = {};
      this.options.forEach((v) => {
        obj[v.id] = v.name;
      });
      return obj;
    },
  },
  watch: {
    selectStru(vl) { this.newSelectStructure = vl; },
    newSelectStructure(vl) { this.$emit('update:selectStru', vl); },
    defaultSelectStructure: {
      handler(vl) {
        this.newDefaultSelectStructure = vl;
      },
      deep: true,
      immediate: true,
    },
    newDefaultSelectStructure: {
      handler(vl) {
        this.$emit('update:defaultSelectStructure', vl);
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.getStructure();
    },
    getTreeData(){
      return this.$refs.tree && this.$refs.tree.getTreeData()
    },
    getCheckeds(){
      return this.$refs.tree && this.$refs.tree.getCheckeds
    },
    getHalfCheckedKeys(){
      return this.$refs.tree && this.$refs.tree.getHalfCheckedKeys
    },
    // 获取学科结构列表
    async getStructure() {
      const res = await this.$http.get('api/imkid/subject');
      console.log('获取学科结构==>', res);
      this.options = res.items.map(v => ({
        ...v,
        value: v.id,
        label: v.name,
      }));

      // 初始化默认选中第一个学科
      if (this.options[0].value) {
        this.selectStructure = this.options[0].value;
        this.newSelectStructure = this.options[0].value;
      }
    },
    onSuccessTree() {
      this.$emit('onStructure', this.newSelectStructure);
    },
    handleSelectStruct() {
      this.selectStructure = this.newSelectStructure;
      this.$emit('onStructure', this.newSelectStructure);
    },
    onTreeBox(data, node) {
      this.$emit('onCatalog', data, node);
    },
    onSelected(data) {
      this.$emit('onSelectedIds', data);
    },
    onCheck(data, node) {
      this.$emit('onCheck', data, node);
    },
    setCheckedKeys(data){
      this.$refs.tree && this.$refs.tree.setCheckedKeys(data)
    }
  },
};
</script>

<style lang="scss" scoped>
.catalog {
  display: flex;
  flex-direction: column;
  margin-right: 10px;

  .list-box{
    width: 260px;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;

    .btn{
      margin-left: 0px;
      margin-right: 6px;
      margin-bottom: 10px;
    }
  }

  .row {
    width: 260px;
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-top: 10px;

    .name {
      font-size: 12px;
      margin-right: 10px;
    }

    &.radio {
      margin-top: 0px;
      .name{
        margin-right: 20px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/CampusManagement/list/authorization/components/catalog/index.vue